/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_New_Release_NotesInputs */

const en_page_title_new_release_notes = /** @type {(inputs: Page_Title_New_Release_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New release notes`)
};

const nl_page_title_new_release_notes = /** @type {(inputs: Page_Title_New_Release_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieuwe release notes`)
};

/**
* | output |
* | --- |
* | "New release notes" |
*
* @param {Page_Title_New_Release_NotesInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_new_release_notes = /** @type {((inputs?: Page_Title_New_Release_NotesInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_New_Release_NotesInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_new_release_notes(inputs)
	return en_page_title_new_release_notes(inputs)
});